export const PACKAGE_CATEGORIES = ["Individual", "Corporate", "Class Pass"];
export const BILLING_CYCLES = ["Weekly", "Monthly", "One-Time", "Free"];
export const LOCATION_TYPES = ["Oakland", "San Francisco", "Silicon Valley", "In-Home Travel", "Virtual"];

export const GOALS = [
  { value: "weight_loss", label: "Lose Weight", icon: "\uD83D\uDD25" },
  { value: "muscle_gain", label: "Build Muscle", icon: "\uD83C\uDFCB\uFE0F" },
  { value: "athletic_performance", label: "Athletic Performance", icon: "\u26A1" },
  { value: "corporate_wellness", label: "Corporate Wellness", icon: "\uD83C\uDFE2" },
  { value: "general_health", label: "General Health & Mobility", icon: "\uD83E\uDDD8" },
];

export const EXPERIENCE_LEVELS = [
  { value: "beginner", label: "Beginner" },
  { value: "intermediate", label: "Intermediate" },
  { value: "advanced", label: "Advanced" },
];

export const LOCATION_PREFERENCES = [
  { value: "oakland", label: "In-Person: Oakland" },
  { value: "san_francisco", label: "In-Person: San Francisco" },
  { value: "silicon_valley", label: "In-Person: Silicon Valley" },
  { value: "online", label: "Online / Virtual" },
];
